var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4 w-full bg-gray-600",staticStyle:{"height":"1px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }